import React from 'react';
import BaseModal from 'app_previous/molecules/Shared/BaseModal/BaseModal';
import { ModalContainer } from './EmailModal.styles';
import useHubspotFormCreation from 'src/hooks/useHubspotFormCreation';
import { usePeopleMagicProfitEmailModalControl } from '../../../../../../hooks/usePeopleMagicProfitEmailModalControl';
import { useProfitSalesHubspotForm } from 'src/hooks/useProfitSalesHubspotForm';
import {
  addTrackHubSpotFormHandling,
  OnFormSubmittedType,
  prefillField,
  removeTrackHubSpotFormHandling,
} from 'src/functions/hubspot/hubspot.service';
import { gTagEvent } from 'src/functions/googleAnalyticsHelper';
import FormContent from 'molecules/EmailPopup/FormContent/FormContent';
import ThankYouMessage from 'molecules/MasterclassSignup/ThankYouMessage';

const FORM_WRAPPER_ID = 'profit-sales-email-modal';

interface EmailModalProps {
  formId?: string;
  storageKey?: string;
}

const EmailModal = ({ formId = '7e14095b-8063-4a8e-8971-1908b704d8f5' }: EmailModalProps): JSX.Element => {
  const { close, isOpen } = usePeopleMagicProfitEmailModalControl();
  const { isSubmitted, setIsSubmitted, setUserEmail, setUserName } = useProfitSalesHubspotForm();

  const onFormReadyCallback = () => {
    // Prefill form position field
    prefillField(FORM_WRAPPER_ID, 'input[name="form_position"]', 'modal-form');

    // timeout so we can wait for the animation to finish
    setTimeout(() => {
      // track form usage with gTag
      addTrackHubSpotFormHandling(FORM_WRAPPER_ID, trackFormInitialized);
    }, 1000);
  };

  const trackFormInitialized = () => {
    gTagEvent('Form_Start', {
      category: 'form',
      label: FORM_WRAPPER_ID,
    });

    // remove the listener so we send it just once
    removeTrackHubSpotFormHandling(FORM_WRAPPER_ID, trackFormInitialized);
  };

  const onFormSubmittedCallback: OnFormSubmittedType = (_, data) => {
    // update context, so we can show thank you for both forms
    setIsSubmitted(true, data?.submissionValues);

    // Set Data so we can remember it later
    if (data?.submissionValues) {
      // set user data
      setUserName(data.submissionValues.firstname);
      setUserEmail(data.submissionValues.email);
    }

    // Track Facebook Pixel
    (window as any).fbq && (window as any).fbq('track', 'Lead');
  };

  useHubspotFormCreation({
    formId,
    formWrapperId: FORM_WRAPPER_ID,
    dependencies: [isSubmitted],
    blockDependencies: [isSubmitted, isOpen],
    onFormReadyCallback,
    onFormSubmittedCallback,
  });

  return (
    <BaseModal
      isVisible={isOpen}
      handleClose={close}
      width={478}
      blockModalClose={isSubmitted}
    >
      <ModalContainer>
        {isSubmitted && isOpen ? (
          <ThankYouMessage />
        ) : (
          <FormContent
            formId={FORM_WRAPPER_ID}
            headingText='Access the full People Magic Profit Masterclass'
            supportingText='We’ll send you the exact formulas you need to start building your $1M community today.'
            legalText='By signing up, you’re opting in to emails from us about the free masterclass, the podcast, and other helpful guides and goodies. You can unsubscribe at any time.'
            buttonText='Unlock People Magic Profit'
          />
        )}
      </ModalContainer>
    </BaseModal>
  );
};

export default EmailModal;
